export const gradeMap = {
    1: '幼儿园小班',
    2: '幼儿园中班',
    3: '幼儿园大班',
    4: '一年级',
    5: '二年级',
    6: '三年级',
    7: '四年级',
    8: '五年级',
    9: '六年级',
    10: '初一',
    11: '初二',
    12: '初三',
    13: '高一',
    14: '高二',
    15: '高三',
}
// 添加反查方法
gradeMap.getKeyByValue = function (value) {
    for (const [key, val] of Object.entries(this)) {
        if (val === value) {
            return parseInt(key); // 返回数字类型的键
        }
    }
    return null; // 如果未找到，返回 null
};
